import { Eye, EyeOff } from 'lucide-react'
import * as React from 'react'
import { cn } from '#app/utils/misc.tsx'
import { Button } from './ui/button'
import { Input } from './ui/input'
import { Label } from './ui/label'

interface PasswordInputProps
	extends React.InputHTMLAttributes<HTMLInputElement> {
	label: string
	id?: string
	error?: string[] | null
}

export default function PasswordInput({
	label,
	id,
	type,
	error,
	className,
	...props
}: PasswordInputProps) {
	const [showPassword, setShowPassword] = React.useState(false)
	const inputId = id || label.toLowerCase().replace(/\s+/g, '-')

	return (
		<div>
			<Label
				htmlFor={inputId}
				className="text-sm font-medium text-gray-600 dark:text-gray-400"
			>
				{label}
			</Label>
			<div className="relative">
				<Input
					type={showPassword ? 'text' : 'password'}
					className={cn(
						'pr-10',
						`${error ? 'border-red-500 focus-visible:ring-red-500' : ''}`,
						className,
					)}
					id={inputId}
					{...props}
				/>
				<Button
					type="button"
					variant="ghost"
					size="sm"
					className="absolute top-0 right-0 h-full ring-offset-0 hover:bg-transparent focus:ring-0"
					onClick={() => setShowPassword(!showPassword)}
					aria-label={showPassword ? 'Hide password' : 'Show password'}
				>
					{showPassword ? (
						<EyeOff className="text-muted-foreground h-4 w-4" />
					) : (
						<Eye className="text-muted-foreground h-4 w-4" />
					)}
				</Button>
			</div>
			{error && <p className="text-xs text-red-500">{error}</p>}
		</div>
	)
}
